import React from 'react'
import Button from '../../../../../../components/buttons/buttons.component'
import PaginationComponent from './../../../../../../components/pagination/pagination.component'
import StyledFlexContainer from './../../../../../../components/containers/flex-container.component'
import { connect } from 'react-redux'
import { isMobile } from './../../../../../../helpers/window.helper'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../../../actions'
import { bindActionCreators } from 'redux'
import {
	MoneyInput,
	NumberInput,
	SelectInput
} from '../../../../../../components/form-components/inputs.component'
import {
	getData,
	renderRow,
	changeOrder,
	addCondition,
	removeCondition,
	updateConditions
} from './payment-conditions.functions'

const Filler = () => (
	<div
		style={isMobile() ? { height: '10px', width: '10px' } : { width: '10px' }}
	/>
)

class PaymentConditionsComponent extends React.Component {
	constructor(props) {
		super(props)
		props.sendData(() => this.state.paymentConditions)
		this.getData = getData.bind(this)
		this.renderRow = renderRow.bind(this)
		this.changeOrder = changeOrder.bind(this)
		this.addCondition = addCondition.bind(this)
		this.removeCondition = removeCondition.bind(this)
		this.updateConditions = updateConditions.bind(this)
		this.state = {
			paymentConditions: []
		}
	}

	componentDidMount() {
		this.refs.pagination.reload()
	}

	componentWillReceiveProps(nextProps) {
		const previousInitialData = this.props.initialData || []
		const nextInitialData = nextProps.initialData || []
		if (previousInitialData.length != nextInitialData.length)
			this.setState({ paymentConditions: nextInitialData }, () =>
				this.refs.pagination.reload()
			)
	}

	render() {
		return (
			<React.Fragment>
				<StyledFlexContainer style={{ marginBottom: '20px' }} marginTop={1}>
					<NumberInput
						id={'points'}
						maxLength={12}
						className={'col-3'}
						label={'Quantidade de pontos'}
						{...this.props}
					/>
					<MoneyInput
						id={'price'}
						className={'col-2'}
						label={'Valor (R$)'}
						{...this.props}
					/>
					<SelectInput
						label={'Clube'}
						className={'col-2'}
						id={'forSubscribers'}
						options={conditionOptions}
						{...this.props}
					/>
					<Filler />
					<Button
						data-permission="93E46D7DB3E2833433E02BDEA4DE655696CBDC59"
						className="add-button"
						primary
						type={'button'}
						onClick={this.addCondition}>
						Adicionar
					</Button>
				</StyledFlexContainer>
				<PaginationComponent
					noTitle
					rowsPerPage={99}
					ref={'pagination'}
					getData={this.getData}
					renderRow={this.renderRow}
					headers={paginationHeaders}
					emptyDatasetText="Adicione condições de pagamento para o produto."
				/>
			</React.Fragment>
		)
	}
}

const paginationHeaders = [
	{ header: 'Ordem', key: 'order' },
	{ header: 'Quantidade de pontos', key: 'points' },
	{ header: 'Valor', key: 'price' },
	{ header: 'Clube', key: 'forSubscribers' },
	{ header: '', key: 'id' }
]

const conditionOptions = [
	{ value: 1, label: 'Sim' },
	{ value: 0, label: 'Não' }
]

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger
		},
		dispatch
	)

const PaymentConditions = withRouter(
	connect(null, mapDispatchToProps)(PaymentConditionsComponent)
)

export default PaymentConditions
